function normalizeStatus(value) {
  const status = Number(value);
  return Number.isInteger(status) && status >= 100 && status <= 599 ? status : undefined;
}

export function logOperationalWarning(operation, details = {}) {
  const payload = {
    operation: String(operation || 'unknown').slice(0, 80),
    ...(normalizeStatus(details.status) ? { status: normalizeStatus(details.status) } : {}),
    ...(details.code ? { code: String(details.code).slice(0, 80) } : {}),
  };
  try { console.warn('[zodiacus]', payload); } catch {}
}

export function logOperationalError(operation, details = {}) {
  const payload = {
    operation: String(operation || 'unknown').slice(0, 80),
    ...(normalizeStatus(details.status) ? { status: normalizeStatus(details.status) } : {}),
    ...(details.code ? { code: String(details.code).slice(0, 80) } : {}),
  };
  try { console.error('[zodiacus]', payload); } catch {}
}
